import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { CheckCircle } from "@phosphor-icons/react";
import { LogoMark } from "../components/Logo";
import PasswordField from "../components/PasswordField";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password troppo corta (min 6)");
    if (password !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Password aggiornata");
      setTimeout(()=>nav("/login"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Token non valido o scaduto");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 py-10">
        <div className="text-center">
          <div className="text-[#FF3B30] font-heading text-3xl font-black uppercase">Link non valido</div>
          <Link to="/login" className="text-[#FFD600] font-bold uppercase mt-4 inline-block">Torna al login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12">
            <LogoMark size={48} />
          </div>
          <div className="font-heading text-3xl font-black uppercase leading-none">ETA<span className="text-[#FFD600]">Build</span></div>
        </div>

        {done ? (
          <div data-testid="reset-done" className="bg-[#FFD600]/10 border-2 border-[#FFD600]/30 rounded-md p-6 text-center">
            <CheckCircle size={48} weight="fill" className="text-[#FFD600] mx-auto mb-3"/>
            <h2 className="font-heading text-3xl font-black uppercase">Fatto!</h2>
            <p className="text-[#A3A3A3] mt-2">Ti stiamo reindirizzando al login…</p>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-5xl font-black uppercase tracking-tighter leading-none mb-2">Nuova password</h1>
            <p className="text-[#A3A3A3] mb-8">Imposta una nuova password per il tuo account.</p>
            <form onSubmit={submit} className="space-y-4">
              <PasswordField label="Nuova password" dataTestId="reset-pwd" value={password} onChange={(e)=>setPassword(e.target.value)} minLength={6} />
              <PasswordField label="Conferma password" dataTestId="reset-pwd2" value={confirm} onChange={(e)=>setConfirm(e.target.value)} minLength={6} />
              <button data-testid="reset-submit" disabled={loading} type="submit"
                className="w-full bg-[#FFD600] text-[#0A0A0A] h-16 text-xl font-black uppercase tracking-tight rounded-md hover:bg-[#E6C200] transition disabled:opacity-50">
                {loading ? "Aggiornamento…" : "Aggiorna password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
